const trimTrailingSlash = (value = "") => value.replace(/\/+$/, "");

const hostname =
  typeof window !== "undefined" ? window.location.hostname : "";

const isLocalHost =
  hostname === "localhost" ||
  hostname === "127.0.0.1" ||
  hostname === "::1";

const configuredBase = trimTrailingSlash(process.env.REACT_APP_API_BASE || "");

const API_BASE = configuredBase || (isLocalHost ? "http://localhost:4000" : "");

export default API_BASE;
